import { render, staticRenderFns } from "./edit-course-modal.vue?vue&type=template&id=e00fbb1c"
import script from "./edit-course-modal.vue?vue&type=script&lang=js"
export * from "./edit-course-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports